import type { WalletTypeResponse } from '@/api/model'

/**
 * What to render for a wallet type reference:
 * - `named`    → the wallet type the entity is explicitly bound to
 * - `fallback` → no wallet type set; the backend resolves it to the company
 *                fallback wallet, whose name we could not determine
 * - `unknown`  → a wallet type id that is not in the company's list
 */
export type WalletTypeDisplay =
  | { kind: 'named'; name: string }
  | { kind: 'fallback' }
  | { kind: 'unknown' }

export function resolveWalletTypeDisplay(
  walletTypeId: string | null | undefined,
  walletTypes: WalletTypeResponse[],
): WalletTypeDisplay {
  // No wallet type set = the company fallback wallet (same rule as the backend budget logic).
  if (!walletTypeId) {
    const fallback = walletTypes.find((walletType) => walletType.isFallback)
    return fallback?.name ? { kind: 'named', name: fallback.name } : { kind: 'fallback' }
  }
  const match = walletTypes.find((walletType) => walletType.id === walletTypeId)
  return match?.name ? { kind: 'named', name: match.name } : { kind: 'unknown' }
}
